"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const events_1 = require("~/utils/events");
// Ownership becomes authoritative only when the socket returns the saved project.
function useGuestProjectSave(currentProject, userId, send, onSaved) {
    const [pending, setPending] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        var _a;
        if (pending &&
            (currentProject === null || currentProject === void 0 ? void 0 : currentProject.id) === pending.id &&
            currentProject.user_id === userId &&
            currentProject.name === pending.name &&
            ((_a = currentProject.permissions) === null || _a === void 0 ? void 0 : _a.edit)) {
            setPending(null);
            onSaved(pending.id);
        }
    }, [pending, currentProject, userId, onSaved]);
    (0, react_1.useEffect)(() => {
        if (!pending) {
            return undefined;
        }
        const timer = setTimeout(() => {
            setPending(null);
            (0, events_1.showNotification)({ message: 'Unable to save your draft. Keep this tab open and try again.', type: 'error' });
        }, 30000);
        return () => clearTimeout(timer);
    }, [pending]);
    const save = (project) => {
        if (pending || !userId) {
            return;
        }
        setPending({ id: project.id, name: project.name });
        send(project);
    };
    return { save, saving: pending !== null };
}
exports.default = useGuestProjectSave;
